var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7725 6.83331L10.0683 14.5741C9.93228 14.7546 9.72942 14.8729 9.50533 14.9024C9.28124 14.9318 9.05472 14.87 8.87665 14.7308L4.80331 11.4741C4.44387 11.1865 4.38567 10.6619 4.67331 10.3025C4.96096 9.94303 5.48554 9.88483 5.84498 10.1725L9.24165 12.89L14.4308 5.84748C14.601 5.59214 14.8977 5.45096 15.2032 5.48001C15.5086 5.50906 15.7734 5.70362 15.8924 5.98646C16.0114 6.26929 15.9653 6.59463 15.7725 6.83331Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.1a6f4af72d919c7d812ff7e526335c4f.svg";
export { ForwardRef as ReactComponent };